 
function isNullish(value) {
    return value === null || value === undefined || value === '';
}
 
class GiftDispatcher extends HTMLElement {
    constructor() {
        super();
        this.gifts = this.querySelectorAll('input[type="hidden"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
 
        this.cartURLs = {
            add: `${routes.cart_add_url}.js`,
            change: `${routes.cart_change_url}.js`,
            update: `${routes.cart_update_url}.js`,
            cart: `${routes.cart_url}.js`,
        };
    }
 
    connectedCallback() {
        if(window.deployerAdapter.enable_gift_dispatcher === true) {
            this.listenEvents();
        }
    }
 
    disconnectedCallback() {
        this.removeEvents();
    }
 
    listenEvents() {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            this.getCart().then(cart => { this.validateConditions(cart)});
        });
    }
 
    removeEvents() {}
 
    async getCart() {
        return fetch(this.cartURLs.cart, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then(response => {
            return response;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
 
    validateConditions(cart) {
        for (const gift of this.gifts) { 
            if (isNullish(gift.dataset.variantId) || isNullish(gift.dataset.tierType)) return;
 
            const variantId = parseInt(gift.dataset.variantId);
            const tierType = gift.dataset.tierType;
            const isSufficient = this.isTierSatisfied(cart, tierType, gift);
 
            if (isSufficient === false) {
                console.warn(`Tier is not sufficient for adding variant gift ${variantId}`);
                this.removeFromCartGift(cart, variantId);
                continue;
            }
            
            if (this.isAlreadyOnCart(cart, variantId)) {
                console.warn(`Variant ${variantId} is already on cart`);
                continue;
            }
 
            this.addToCartGift(variantId);
        }
    }
 
    isTierSatisfied(cart, type, gift) {
        switch (type) {
            case 'cart_items_count':
                return GiftDispatcherOnCartItemsCount.validateConditions(cart, gift);
            case 'cart_amount':
                return GiftDispatcherOnCartAmount.validateConditions(cart, gift);
            case 'product_on_cart':
                return GiftDispatcherOnProductInCart.validateConditions(cart, gift);
            default:
                return false;
        }
    }
 
    isAlreadyOnCart(cart, variantId) {
        return cart.items.some((item) => item.variant_id == variantId);
    }
 
    updateCart(response) {
        if(this.cart) {
            this.cart.renderContents(response);
        }
    }
 
    async addToCartGift(variantId) {
        let bodyConfig = JSON.stringify({
            items: [
                {
                    id: variantId,
                    quantity: 1,
                },
            ],
        });
 
        if(this.cart) {
            bodyConfig = JSON.stringify({
                items: [
                    {
                        id: variantId,
                        quantity: 1,
                    },
                ],
                sections: this.cart.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
            });
        }
 
        return fetch(this.cartURLs.add, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodyConfig, 
        })
        .then((response) => response.json())
        .then((response) => {
            this.updateCart(response);
        }).catch((error) => {
            console.error('Error adding gift to cart:', error);
        });
    }

    async removeFromCartGift(cart, variantId) {
        let lineIndex = cart.items.findIndex(
          (item) => item.variant_id == variantId
        );
        if (lineIndex === -1) return;
        
        let item = cart.items.find(
          (item) => item.variant_id == variantId
        );
        let key = item.key;

        let bodyConfig = JSON.stringify({
          id: key,
          quantity: 0,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });

        return fetch(this.cartURLs.change, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: bodyConfig,
        })
          .then((response) => response.json())
          .then((response) => {
            this.updateCart(response);
          })
          .catch((error) => {
            console.error("Error removing gift from cart:", error);
          });
    }
}
 
customElements.define('gift-dispatcher', GiftDispatcher);
 
  
var GiftDispatcherOnCartAmount = class {
  
    static isCartAmountSufficient(cart, cartAmount) {
        const cartTotal = cart.items_subtotal_price;
        return cartTotal >= cartAmount;
    }
  
    static validateConditions(cart, gift) {
        if (isNullish(gift.dataset.cartAmount)) return false;
 
        const cartAmount = parseFloat(gift.dataset.cartAmount);
        const isSufficient = this.isCartAmountSufficient(cart, cartAmount);
        const isAvailable = gift.dataset.variantAvailable === "true";
 
        if (!isSufficient) {
            // console.warn(`Tier is not sufficient for adding gift ${variantId}`);
            return false;
        }
 
        if (!isAvailable) {
            // console.warn(`Gift ${variantId} is not available`);
            return false;
        }
 
        return true;
    }
}
  
var GiftDispatcherOnCartItemsCount = class {
    static isCartItemsCountSufficient(cart, cartItemsCount) {
        const cartItems = cart.item_count;
        return cartItems >= cartItemsCount;
    }
 
    static validateConditions(cart, gift) {
        if (isNullish(gift.dataset.cartItemsCount)) return false;
 
        const cartItemsCount = parseInt(gift.dataset.cartItemsCount);
        const isSufficient = this.isCartItemsCountSufficient(cart, cartItemsCount);
        const isAvailable = gift.dataset.variantAvailable === "true";
 
        if (!isSufficient) {
            // console.warn(`Tier is not sufficient for adding gift ${variantId}`);
            return false;
        }
 
        if (!isAvailable) {
            // console.warn(`Gift ${variantId} is not available`);
            return false;
        }
 
        return true;
    }
  }
  
var GiftDispatcherOnProductInCart = class {
    static isProductDispatcherOnCart(cart, productId) {
        return cart.items.some((item) => item.product_id == productId);
    }
 
    static validateConditions(cart, gift) {
        if (isNullish(gift.dataset.variantId)) {
            // console.warn("Variant ID is not defined");
            return false;
        }
 
        
        const isAvailable = gift.dataset.variantAvailable === "true";
        const productDispatcherId = parseInt(gift.dataset.productDispatcherId);
        const isProductDispatcherOnCart = this.isProductDispatcherOnCart(cart, productDispatcherId);
 
        if(!isProductDispatcherOnCart) {
            // console.warn(`Dispatcher is not on cart`);
            return false;
        }
 
        if (!isAvailable) {
            // console.warn(`Gift ${variantId} is not available`);
            return false;
        }
 
        return true;
    }
}
  
 
 